import { joinParts } from './utils'

export const tickets = {
  secret: (secret: string) => joinParts('tickets', secret),
}
